<div class="searchbar-top student-view-top">
    <div class="student-testname">
        <h4>
            <div class="back-headingicon cursor-pointer d-flex" (click)="backButtoEvent()">
                <i class="fa-solid fa-arrow-left-long me-2 mt-1"></i>
            </div>
            {{TestName}}
        </h4>
    </div>
    <div class="top-group-wrap gap-2">
        <div class="text-center d-flex flex-column align-items-strech justify-content-center m-0">
            <div class="xmtime">{{TestDuration}}</div>
            <div class="date-xmduration d-flex align-items-center justify-content-end">
                <p>{{TestDate | date: 'dd/MM/yyyy'}}</p>
                <p>{{StartTime | date: 'hh:mm a' }} To {{EndTime |date: 'hh:mm a' }}</p>
            </div>
        </div>
        <div class="failpassfieldgroup m-0">
            <select class="form-control ng-untouched ng-pristine form-select ng-valid form-control-lg"
                [(ngModel)]="submitTypeFilter" (change)="onSubmitTypeChanages(submitTypeFilter)">
                <option value="">All</option>
                <ng-container *ngFor="let type of SubmitTypeList">
                    <option [value]="type.id">{{type.value}}</option>
                </ng-container>
            </select>
        </div>
        <div class="failpassfieldgroup m-0">
            <select class="form-control ng-untouched ng-pristine form-select ng-valid form-control-lg"
                [(ngModel)]="resultFilter" (change)="onSelectChange(resultFilter)">
                <option value="">All</option>
                <ng-container *ngFor="let result of resultList">
                    <option [value]="result.value">{{result.value}}</option>
                </ng-container>
            </select>
        </div>
        <div class="input-group searchfieldgroup m-0">
            <input type="text" class="form-control" [(ngModel)]="enterSearch" placeholder="Search...." oninput="this.value = this.value.replace(/^\s+/g, '')"
                aria-label="Search" aria-describedby="search-addon" (keyup)="search($event)" />
            <span class="input-group-text border-0" id="search-addon">
                <i class="fas fa-search"></i>
            </span>
            <span type="button" class="input-group-append" (click)="cancelSearch()" *ngIf="searchClose">
                <i class="fas fa-times"></i>
            </span>
        </div>
        <button type="button" class="btn btn-primary common-button m-0"
            (click)="PendingResult()"><span>{{TestConstant.PendingStudents}}</span></button>
        <button type="button" #RefreshGridBtn class="btn btn-primary common-button m-0 icon-btn"
            (click)="RefreshGrid()"><i class="fa-solid fa-rotate-right"></i></button>
        <div class="dropdown exportdropdown" *ngIf="exportButton">
            <a class="btn btn-primary common-button m-0" type="button" id="dropdownMenuButton1"
                data-bs-toggle="dropdown" aria-expanded="false">
                <img src="../../../../assets/img/downloadicon.svg" alt="logo" class="img-fluid pe-2">
                <span>Export</span>
                <i class="fa-solid fa-angle-down ms-3"></i>
            </a>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li><a class="dropdown-item" (click)="ExportResult()" title="Export Excel">{{TestConstant.Export}}</a>
                </li>
                <li><a class="dropdown-item" (click)="downloadPdf()" title="Export PDF">{{ TestConstant.ExportPdf }}</a>
                </li>
            </ul>
        </div>
    </div>
</div>
<div class="card-content">
    <div class="row table-touch ">
        <div class="col-sm-12">
            <div class="d-flex align-items-center justify-content-between borderset">
                <label class="text-danger"><b>Note:</b> Student must have {{cutoff}} marks of passing</label>
                <div class="d-flex align-items-center">
                    <label class="datetime me-4 d-flex align-items-center"><img src="../../../../assets/img/calnder.svg"
                            alt="image">{{TestDate | date: 'dd/MM/yyyy'}}</label>
                    <label class="datetime d-flex align-items-center"><img src="../../../../assets/img/clock.svg"
                            alt="image"> {{TestDuration}}</label>
                </div>

            </div>
        </div>
    </div>
    <div class="row table-touch">
        <div class="col-sm-12">
            <div class="mat-custom-table">
                <div class="table-responsive">
                    <table mat-table matSort [dataSource]="dataSource" (matSortChange)="SortChange($event)"
                        aria-describedby="list">
                        <ng-container matColumnDef="rowNumber">
                            <th mat-header-cell *matHeaderCellDef>{{CommonConstant.SR}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.rowNumber}} </td>
                        </ng-container>
                        <ng-container matColumnDef="studentName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{TestConstant.NameOfStudent}}
                            </th>
                            <td mat-cell *matCellDef="let element"> {{element.studentName}} </td>
                        </ng-container>
                        <ng-container matColumnDef="EmailId">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{TestConstant.EmailId}}
                            </th>
                            <td mat-cell *matCellDef="let element"> {{element.emailId}}</td>
                        </ng-container>
                        <ng-container matColumnDef="MobileNo">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{TestConstant.PhoneNumber}}
                            </th>
                            <td mat-cell *matCellDef="let element"> {{element.mobileNo}} </td>
                        </ng-container>
                        <ng-container matColumnDef="startTime">
                            <th mat-header-cell *matHeaderCellDef> {{TestConstant.StartTime}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.startDateTime | date: 'hh:mm:ss a'}} </td>
                        </ng-container>
                        <ng-container matColumnDef="endTime">
                            <th mat-header-cell *matHeaderCellDef>{{TestConstant.EndTime}}</th>
                            <td mat-cell *matCellDef="let element"> {{element.endDateTime | date: 'hh:mm:ss a' }} </td>
                        </ng-container>
                        <ng-container matColumnDef="wrong">
                            <th mat-header-cell *matHeaderCellDef> {{TestConstant.Wrong}}</th>
                            <td mat-cell *matCellDef="let element"> {{ element.wrongAns}} </td>
                        </ng-container>
                        <ng-container matColumnDef="markScores">
                            <th mat-header-cell *matHeaderCellDef> {{TestConstant.MarkScores}}
                            </th>
                            <td mat-cell *matCellDef="let element"> {{element.correctAns}}/{{element.totalQuestion}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="result">
                            <th mat-header-cell *matHeaderCellDef> {{TestConstant.Result}} </th>
                            <td mat-cell *matCellDef="let element">
                                <span *ngIf="element.submitType == 'Start'"
                                    class="text-secondry">{{CommonConstant.PENDING}}</span>
                                <span *ngIf="element.result == 'Fail' && element.submitType != 'Start'"
                                    class="text-danger">{{element.result}} </span>
                                <span *ngIf="element.result == 'Pass' && element.submitType != 'Start'"
                                    class="text-success">{{element.result}} </span>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="submitType">
                            <th mat-header-cell *matHeaderCellDef> {{TestConstant.SUBMIT_TYPE}} </th>
                            <td mat-cell *matCellDef="let element">
                                <span *ngIf="element.submitType == 'Background'"
                                    class="text-danger">{{TestResult.Background}} </span>
                                <span *ngIf="element.submitType == 'Submit'" class="text-success">{{TestResult.Submit}}
                                </span>
                                <span *ngIf="element.submitType == 'Timeout'" class="text-yellow">{{TestResult.Timeout}}
                                </span>
                                <span *ngIf="element.submitType == 'ReSubmission'"
                                    class="text-blue">{{TestResult.ReSubmission}} </span>
                                <span *ngIf="element.submitType == 'Start'" class="text-secondry">{{TestResult.Start}}
                                </span>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="Action">
                            <th mat-header-cell *matHeaderCellDef> {{CommonConstant.ACTION}} </th>
                            <td mat-cell *matCellDef="let element">
                                <div class="action-button-group">
                                    <a class="detailicon" title="Student Result Details"
                                        (click)="ViewResult(element.examSubmitId)"><svg
                                            xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#fff"
                                            class="bi bi-info-lg" viewBox="0 0 16 16">
                                            <path
                                                d="m9.708 6.075-3.024.379-.108.502.595.108c.387.093.464.232.38.619l-.975 4.577c-.255 1.183.14 1.74 1.067 1.74.72 0 1.554-.332 1.933-.789l.116-.549c-.263.232-.65.325-.905.325-.363 0-.494-.255-.402-.704l1.323-6.208Zm.091-2.755a1.32 1.32 0 1 1-2.64 0 1.32 1.32 0 0 1 2.64 0Z" />
                                        </svg>
                                    </a>
                                    <a class="editicon restarticon" title="Student Result Edit"
                                        *ngIf="element.submitType == 'Background' && element.isRestart == false && testResult"
                                        (click)="Restart(element.examSubmitId,element.studentName,element.studentId)"><i
                                            class="fa-solid fa-arrows-rotate"></i></a>
                                    <a class="deleteicon" title="Student Result Delete"
                                        (click)="Deletepopup(element.examSubmitId,element.studentName)"><i class="fa fa-trash"></i></a>
                                </div>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                    <div *ngIf="showData" [ngClass]="dataSource.filteredData.length > 0 ? 'hidden' : 'visible'">
                        <h5 class="text-center no-data-available py-4">{{NoRecordFound.NoStudenrResultFound}}</h5>
                    </div>
                </div>
                <mat-paginator #paginator [length]="totalRows" [pageIndex]="currentPage" showFirstLastButtons
                    [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" (page)="pageChanged($event)"
                    aria-label="Select page">
                </mat-paginator>
            </div>
        </div>
    </div>
</div>